import { useId } from "react";
import { TextBox, type TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { useTranslation } from "react-i18next";

interface InventoryHoldingDaysProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  validationMessage?: string;
  starlable?: boolean;
  disable?: boolean;
  max?: number;
}

const InventoryHoldingDays: React.FC<InventoryHoldingDaysProps> = ({
  label = "",
  value,
  onChange,
  validationMessage,
  starlable = false,
  disable = false,
  max = 200,
}) => {
  const { t } = useTranslation();
  const inputId = useId();
  const errorId = `${inputId}-error`;

  const handleChange = (e: TextBoxChangeEvent) => {
    let newValue = String(e.value ?? "").slice(0, max);
    newValue = newValue.replace(/[^\w\s.,\-/#]/g, "");
    onChange(newValue);
  };

  const isInvalid = Boolean(validationMessage);

  return (
    <div className="gx_input_container">
      <label
        htmlFor={inputId}
        className={`input-label-noicon gx-font-semibold ${value ? "floating" : ""}`}
      >
        {t(label)}

        {starlable && (
          <span
            className={`gx_input_star ${
              value ? "gx_input_star_float" : "gx_input_star_normal"
            }`}
            aria-hidden="true"
          >
            *
          </span>
        )}
      </label>

      <div className={`gx_input_cont ${isInvalid ? "invalid" : "valid"}`}>
        <TextBox
          id={inputId}
          value={value}
          onChange={handleChange}
          disabled={disable}
          maxLength={max}
          className="gx-textbox-css"
          required={starlable}
          aria-required={starlable}
          aria-invalid={isInvalid}
          aria-describedby={isInvalid ? errorId : undefined}
          autoComplete="street-address"
          spellCheck={true}
        />
      </div>

      {validationMessage && (
        <div
          id={errorId}
          className="gx_input_validationmessage"
          role="alert"
          aria-live="assertive"
        >
          {validationMessage}
        </div>
      )}
    </div>
  );
};

export default InventoryHoldingDays;
